export default "__VITE_ASSET__a3bbef24__"